
import type { Commit, Dispatch } from 'vuex'
import { getCustomerMessageNum } from '@/apis/user'

const dp = new Map()

export default {
  namespaced: true,
  state: {
    num: 0,
    cart: 0,
    cartSummaryDTOList: [],
    dp
  },
  getters: {
    getMessageNum (state: { num: number }): number {
      return state.num
    }
  },
  mutations: {
    SET_MESSAGE_NUM: (
      state: { num: number },
      num: number
    ): void => {
      state.num = num
    }
  },
  actions: {
    getMessageNum (
      { commit, rootState }: { commit: Commit, rootState:any }
    ):void {
      if (!rootState.route.token) return
      getCustomerMessageNum().then((res: any) => {
        commit('SET_MESSAGE_NUM', res?.data)
      })
    },
    subscrible ({ state }:any, [key, fn]:any):void {
      if (state.dp.has(key)) return
      state.dp.set(key, fn)
      if (key === 'message') {
        setInterval(fn, 5 * 60 * 1000)
      }
    }
  }
}

// storage同一窗口下无法监听
window.addEventListener('storage', (res:any) => {
  if (res.key === '_update_global_state_') {
    [...dp].forEach(([key, fn]:any) => fn())
  }
  if (res.key === '_reload_page_') {
    location.reload()
  }
}, true)

window.addEventListener('message', (res:any) => {
  const { updateGlobalState } = res.data ?? {}
  if (updateGlobalState) {
    [...dp].forEach(([key, fn]:any) => fn())
  }
})
